var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.162 18.3535C14.7114 18.8041 13.9809 18.8041 13.5303 18.3535L8.33795 13.1611C7.88735 12.7105 7.88735 11.98 8.33795 11.5294L13.5303 6.33705C13.9809 5.88645 14.7114 5.88645 15.162 6.33705C15.6127 6.78766 15.6127 7.51823 15.162 7.96884L10.7856 12.3453L15.162 16.7217C15.6127 17.1723 15.6127 17.9028 15.162 18.3535Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.34652e8b810b8b930d63081ed0d47ecb.svg";
export { ForwardRef as ReactComponent };